// Global API config for AIS Karaoke

export const API_DOMAIN = process.env.NEXT_PUBLIC_API_BASE_URL;
